import { render, staticRenderFns } from "./ReservationsBookPending.vue?vue&type=template&id=16aecb8f&scoped=true"
import script from "./ReservationsBookPending.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsBookPending.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aecb8f",
  null
  
)

export default component.exports